import {FlowRestoreState, FlowModuleEvents, FlowModule} from '@gongxigames/framework/slot';

export class GameFlowRestoreState extends FlowRestoreState {
    protected restorePickBonus(): void {
        const isBonusStart = this.module.logic.getPickedValues()!.length === 0;

        if (isBonusStart) {
            this.emit(FlowModuleEvents.START_PICK_BONUS);
        } else {
            this.emit(FlowModuleEvents.RESTORE_PICK_BONUS);
        }
        this.module.gotoState(FlowModule.BASIC_STATE);
    }
}
